import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from "persianjs"

import { PureComponent, GroupBox } from 'core/components';
import { withLocale, withAuth } from 'core/decorators';
import { Icon, List, ListInput, Button, CardContent } from 'core/components/Framework7';
import { editProfile, Login } from 'core/module/operations';

import classes from './styles.module.css';

class EditProfile extends PureComponent {
  constructor(props) {
    super(props)

    const { user } = this.props;
    this.router = this.$f7.views.current && this.$f7.views.current.router

    this.state = {
      firstName: user && user.firstName || '',
      lastName: user && user.lastName || '',
      email: '',
      password: '',
      newPassword: '',
      newPasswordRepeat: '',
    }
  }

  get initialValue() {
    const { user, env } = this.props;

    return {
      page: env && env.pages && env.pages.editProfile,
      firstName: user && user.firstName || '',
      lastName: user && user.lastName || '',
      username: user && user.username || '',
      email: user && user.email || '',
    }
  }

  changeEmail(e) {
    this.setState({
      email: e.target.value
    })
  }

  handlePassword(e) {
    this.setState({
      password: e.target.value
    })
  }

  handleNewPassword(e) {
    this.setState({
      newPassword: e.target.value
    })
  }

  handleNewPasswordRepeat(e) {
    this.setState({
      newPasswordRepeat: e.target.value
    })
  }

  handleNext() {
    const user = this.initialValue;
    const { email, password, newPassword, router } = this.state;

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    const model = {
      username: user.username,
      old_password: password,
      password: newPassword,
    }

    const params = {
      errorHandler: true
    }

    this.props.editProfile(model, params)
      .then(r => {
        this.$f7.dialog.alert('اطلاعات حساب کاربری با موفقیت تغییر یافت', 'تغییر حساب کاربری');
        // this.props.navigate.navigate('/profile')
        this.router && this.router.back()
      })
      .catch(e => {
        console.log(e)
        this.$f7.dialog.alert('در سیستم خطایی رخ داده است لطفا دوباره تلاش کنید.', 'خطا');
      })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  hasError() {
    const { password, newPassword, newPasswordRepeat } = this.state;

    let valid = true

    if (
      (!password || password.length == 0) ||
      (!newPassword || newPassword.length < 4) ||
      (!newPasswordRepeat || newPasswordRepeat != newPassword)
    ) {
      valid = false
    }

    return !valid
  }

  onSubmit(e) {
    e.preventDefault();
  }

  render() {
    const user = this.initialValue;
    const { email, password, newPassword, newPasswordRepeat } = this.state

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='تغییر اطلاعات کاربری'>
            <CardContent>
              <React.Fragment>
                <div className={classes.fullName}>
                  {`${user.firstName} ${user.lastName}`}
                </div>
                <List noHairlinesMd>
                  <ListInput
                    type="password"
                    // label={'رمز عبور'}
                    clearButton
                    required
                    validate
                    value={password}
                    placeholder="رمز عبور فعلی را وارد کنید"
                    info={'اجباری، حداقل ۴ حرف'}
                    errorMessage={'لطفا رمز عبور فعلی خود را وارد کنید'}
                    onInputClear={() => this.setState({ password: '' })}
                    onChange={this.handlePassword}
                  >
                    <Icon icon="mdi-account-key-outline" slot="media" />
                  </ListInput>

                  <ListInput
                    type="password"
                    // label={'رمز عبور'}
                    clearButton
                    required
                    validate
                    value={newPassword}
                    placeholder="رمز عبور جدید را وارد کنید"
                    info={'اجباری، حداقل ۴ حرف'}
                    errorMessage={'لطفا رمز عبور جدید خود را وارد کنید'}
                    onInputClear={() => this.setState({ newPassword: '' })}
                    onChange={this.handleNewPassword}
                  >
                    <Icon icon="mdi-account-key" slot="media" />
                  </ListInput>

                  <ListInput
                    type="password"
                    // label={'تکرار رمز عبور'}
                    clearButton
                    required
                    validate
                    value={newPasswordRepeat}
                    placeholder="رمز عبور جدید را مجدد وارد کنید"
                    info={'اجباری'}
                    onInputClear={() => this.setState({ newPasswordRepeat: '' })}
                    errorMessage={'لطفا رمز عبور جدید را مجدد وارد کنید'}
                    onChange={this.handleNewPasswordRepeat}
                  >
                    <Icon icon="mdi-account-key" slot="media" />
                  </ListInput>
                </List>
              </React.Fragment>
            </CardContent>
          </GroupBox>
        </div>

        <Button large fill
          type="submit"
          icon="mdi-account-check"
          text={'بروزرسانی'}
          className={`${classes.fullWidthButton}`}
          disabled={this.hasError()}
          onClick={this.handleNext}
        />
      </form>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    user: state.General.user,
  }),
  {
    editProfile,
    Login,
  }
)(withLocale('editProfile')(withAuth(autobind(EditProfile))))